import React, { useEffect, useState } from 'react'
import { deliveryUserState, deliveryUltimosPedidosState } from '../../store/recoilData'
import { useRecoilState, useRecoilValue } from 'recoil'
import { Avatar, Button, Flex, Modal, List, Divider, Drawer, Tag } from 'antd'
import { useParams, useLocation, useOutletContext } from 'react-router-dom'
import LoginCtrl from './loginCtrl'
import FECHADURA from '../../img/buraco-da-fechadura.png'
import { useToasts } from 'react-toast-notifications'
import { getPedidos } from '../../services/bd/cardapioDigital'
import { CalendarOutlined, FieldTimeOutlined, LeftOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import BAGPEDIDOS from '../../img/shopping-bag.png'
import CupomCtrl from './cupomCtrl'



export const Pedidos = (props) => {

    const { addToast } = useToasts()
    const params = useParams()
    const [userDelivery, setUserDelivery] = useRecoilState(deliveryUserState)
    const [data, setData] = useState([])
    const [data2, setData2] = useRecoilState(deliveryUltimosPedidosState)
    const [loading, setLoading] = useState(false)
    const [app] = useOutletContext();

    const [openPedido, setOpenPedido] = useState(false)
    const [selected, setSelected] = useState(undefined)

    useEffect(() => {
        //  console.log(params, location)
        //  console.log(userDelivery)
        //  setUserDelivery(undefined)
        if (userDelivery) {
            loadPedidos()
        } else {

        }
    }, [])

    async function loadPedidos() {
        try {
            setLoading(true)
            const resp = await getPedidos(userDelivery?.token)
            setData(resp)
           

        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoading(false)
    }


    return <Flex style={{ padding: 20 }} vertical>
        <Flex justify='center' style={{ marginTop: 15 }}>
            <Avatar src={BAGPEDIDOS} shape='square' size={80} />
        </Flex>
        <Flex justify='center'>
            <h6> Meus Pedidos </h6>
        </Flex>

        <List
            style={{ backgroundColor: 'white', marginTop: 15, marginBottom:30 }}
            bordered
            loading={loading}
            size='small'
            dataSource={userDelivery ? data : data2}

            renderItem={(item, index) =>
            (
                <List.Item
                    onClick={() => {
                        setSelected(item)
                        setOpenPedido(true)
                    }}
                    key={item.title}
                    actions={[
                        <Tag color={item.canceled === 1 ? 'red' : 'green'} >
                            <Flex gap={5} justify='center' align='center' style={{textAlign:'center'}}>Pedido: {item.idsales} </Flex>
                        </Tag>,
                    ]}
                    extra={
                        <Flex align='center' style={{minWidth:60}} justify='flex-end'>
                       { "R$".concat(item.total ? item.total : item.subtotal.toFixed(2))}
                        </Flex>
                    }
                >
                    <List.Item.Meta
                        avatar={<Flex gap={5} vertical justify='center' align='center'>
                            <FieldTimeOutlined />
                            {dayjs(item.createAt).format('HH:mm')}
                        </Flex>}
                        title={dayjs(item.createAt).format('DD/MM/YYYY')}
                        description={item.bairro}
                    />
                    {item.content}
                </List.Item>
            )
            }
        />



        {selected && <Drawer
            destroyOnClose={true}
            width={'100%'}
            open={openPedido}
            title={null}
            closable={false}
            footer={null}>
            <Flex vertical gap={5}>
                <Flex gap={10} align='center'>
                    <Button size='small' type='text' icon={<LeftOutlined />} onClick={() => setOpenPedido(false)}></Button>
                    <b>   <span style={{ fontSize: '1.1em' }}>Pedido: <span style={{ color: '#000' }}>{selected?.idsales}</span></span> </b>
                </Flex>
                <CupomCtrl saleid={selected.idsales} app={app} />
            </Flex>
            <Divider style={{ marginTop: 3, marginBottom: 3 }} />
        </Drawer>
        }


    </Flex>
}


export default Pedidos